<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="status.name"
              [disabled]="(form$ | async)?.isEdit"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Описание</label>
            <small
              *ngIf="status?.description?.length >= 35"
              class="p-error">
              *Ограничение до 35 символов
            </small>

            <crm-input-text
              [(value)]="status.description"
              [isError]="$any(errors?.description)"></crm-input-text>
            <small
              *ngIf="errors?.description"
              class="p-error">
              {{ errors.description | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Аудиторы</label>
            <crm-user-multi-select
              [(selectedUsers)]="status.auditors"
              [isError]="$any(errors?.auditors)"
              [isFloatLabel]="false"
              appendTo="body">
            </crm-user-multi-select>
            <small
              *ngIf="errors?.auditors"
              class="p-error">
              {{ errors.auditors | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Цвет</label>
            <div>
              <crm-color-picker [(color)]="status.color"></crm-color-picker>
            </div>
            <div class="p-inputgroup crm-hex-inputgroup mt-2">
              <span class="p-inputgroup-addon">Hex</span>
              <crm-input-text
                [value]="status.color"
                (valueChange)="changeColor($event)"
                [isError]="$any(errors?.color)"></crm-input-text>
            </div>

            <small
              *ngIf="errors?.color"
              class="p-error">
              {{ errors.color | join }}
            </small>
          </div>

          <p-divider></p-divider>
          <div class="field">
            <label class="font-medium">Предпросмотр</label>
            <div>
              <crm-status-label
                [name]="status.name"
                [color]="status.color"></crm-status-label>
            </div>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        styleClass="p-button-success"
        [label]="saveButtonLabel"
        (onClick)="saveStatus()"></crm-button>
      <crm-button
        *ngIf="(form$ | async)?.isShowDelete"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteStatus()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
